import { type FC } from 'react'

import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import {
  ProductInsurancePrescriptionBonusDialog,
  ProductPrivatePrescriptionBonusDialog,
} from '../../../product'
import { useProductPageContext } from '../productPageContext'

export const ProductPrescriptionBonusDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const { currentPrescriptionType } = useProductPageContext()

  const isInsuranceOrFreePrescription =
    currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.InsurancePrescription ||
    currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.FreePrescription

  return (
    <>
      {currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.PrivatePrescription ? (
        <ProductPrivatePrescriptionBonusDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      ) : null}
      {isInsuranceOrFreePrescription ? (
        <ProductInsurancePrescriptionBonusDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      ) : null}
    </>
  )
}
